import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseButton from '../CloseButton/CloseButton';

const HeaderContainer = ({ children }) => (
  <Box display="flex" justifyContent="flex-start" alignItems="flex-start" mb={2} sx={{ gap: 2 }}>
    {children}
  </Box>
);

const HeaderTitle = (props) => (
  <Typography
    {...props}
    sx={{
      fontWeight: 500,
      flex: '1 1 auto',
      minWidth: 0,
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
      whiteSpace: 'normal'
    }}
  />
);

function PrivacyPolicy() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      {/* position relative so CloseButton can be absolutely positioned */}
      <Paper elevation={2} sx={{ p: 4, position: 'relative' }}>
        <HeaderContainer>
          <HeaderTitle variant="h3" component="h1">
            {t('privacyPolicyTitle')}
          </HeaderTitle>
          <CloseButton
            onClick={() => navigate('/')}
            size="small"
            color="primary"
            sx={{ position: 'absolute', top: 8, right: 8, zIndex: 2 }}
          />
        </HeaderContainer>
        
        <Typography variant="body2" align="center" color="text.secondary" gutterBottom>
          {t('lastUpdated')}: October 2025
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('dataCollectionTitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('dataCollectionText')}
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('informationWeCollectTitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('informationWeCollectText')}
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('howWeUseDataTitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('howWeUseDataText')}
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('dataSharingTitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('dataSharingText')}
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('dataSecurityTitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('dataSecurityText')}
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('securityMonitoringTitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('securityMonitoringText')}
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('abusePreventionTitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('abusePreventionText')}
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('dataRetentionTitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('dataRetentionText')}
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('processingLocationTitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('processingLocationText')}
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('automatedDecisionsTitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('automatedDecisionsText')}
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('yourRightsTitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('yourRightsText')}
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('cookiesTitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('cookiesText')}
          </Typography>
        </Box>

        <Box sx={{ mt: 4, p: 2, bgcolor: 'primary.light', color: 'primary.contrastText', borderRadius: 1 }}>
          <Typography variant="body2" align="center">
            {t('privacyContact')}
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}

export default PrivacyPolicy;
